import NotListedLocationIcon from '@mui/icons-material/NotListedLocation';

import i18n from 'FRONTEND/utils/i18n';

export const getLocationStepSupport = () => ({
  title: i18n._('Location selection'),
  text: i18n._('Please select the location where the meeting will take place.'),
  paragraphList: [
    {
      title: i18n._('No locations available?'),
      text: i18n._('If no location is available for appointments, it is necessary to add availability to the mobile resource calendar.'),
      icon: NotListedLocationIcon,
    },
  ],
});
